var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GridYAxis',{attrs:{"align-bottom":_vm.alignBottom,"labels":_vm.labels,"box-height":_vm.boxHeight}})}
var staticRenderFns = []

export { render, staticRenderFns }